<template>
  <div ref="pildoraParent" class="panel bg- panel-grid-item" :style="{'background-color' : colorPildora,'height': '100%', 'color': '#FFF'}">
    <!-- Icono mover/eliminar pildora -->
    <div :class="{ 'vue-draggable-handle glyphicon glyphicon-move': editable }"></div>
    <!-- //Icono mover/eliminar pildora -->
    <div class="panel-body" style="height: 100%;" v-if="editable">
      <div
        :class="{ 'vue-removable-handle glyphicon glyphicon-remove': editable }"
        @click="onClickEliminar()"
      ></div>
      <!-- //Icono mover/eliminar pildora -->
      <!-- Nombre de la pildora -->
      <h6
        class="no-margin"
      >{{ config.name !== null && config.name !== undefined ? config.name : "" }}</h6>
      <!-- //Nombre de la pildora -->
    </div>
    <div style="height: 100%;" v-else>
      <div class="panel-body" style="height: 70%;">
        <!-- Id de la pildora -->
        <div class="heading-elements" v-if="formatValor2!==''">
          <div class="text-size-large"> <i :class="pintarFlecha" class="flecha-pildora" :style="(this.data.bip_valor_1 < this.data.bip_valor_3 ? 'color:red;' : 'color:#00ff43;')"></i> {{ formatValor2 }}</div>
        </div>
        <!-- //Id de la pildora -->
        <div
          :class="{ 'vue-removable-handle glyphicon glyphicon-remove': editable }"
          @click="onClickEliminar()"
        ></div>
        <!-- //Icono mover/eliminar pildora -->
        <!-- Valores principales -->
        <div class="text-size-small mb-1">{{ formatValor3 }}</div>
        {{ nombrePildora }}
        <h3 class="no-margin">{{ formatValor1 }}</h3>
        <!-- //Valores principales -->
      </div>
      <!-- Grafico -->
      <div class="container-fluid" style="height: 30%;">
        <GChart
          ref="grafico"
          v-if="pintarGrafico"
          :type="formatTipoGrafico"
          :data="chartData"
          :options="chartOptions"
          :resizeDebounce="200"
        />
      </div>
    </div>
    <!-- //Grafico -->
  </div>
</template>
<script>
import { GChart } from "vue-google-charts";
import { Util } from "@/api/Util";

const util = new Util();

export default {
  props: {
    data: Object,
    config: Object,
    editable: Boolean,
    altura: Number,
    id: Number
  },
  components: {
    GChart
  },
  data() {
    return {
      bip_item_id: Number(this.$route.query.tienda),
      colorPorDefecto: "#999",
      graficoPorDefecto: "ColumnChart",
      // El primer array tiene que ser de rol tooltip apra que muestre tooltip personalizado
      chartData: [
        ["", "", { type: "string", role: "tooltip", p: { html: true } }]
      ],
      chartOptions: {
        chart: {},
        width: 0,
        height: "45",
        backgroundColor: "transparent",
        colors: ["#ffffff"],
        dataOpacity: 0.4,
        chartArea: {
          top: 0,
          left: 0,
          height: "40",
          width: "80%"
        },
        bar: { groupWidth: "78%" },
        hAxis: {
          baselineColor: "none",
          ticks: [],
          textPosition: "none"
        },
        vAxis: {
          baselineColor: "none",
          ticks: [],
          textPosition: "none"
        },
        legend: { position: "none" },
        tooltip: { isHtml: true }
      }
    };
  },
  watch: {
    data: {
      handler(n, o) {
        if (o === undefined || n !== o) {
          this.populateChartData();
          this.setGraficoWidth();
        }
      },
      deep: true
    },
    editable: {
      handler(n, o) {
        if (n !== o) {
          // this.$refs.grafico;
          this.populateChartData();
          this.setGraficoWidth();
        }
      },
      deep: true
    }
  },
  mounted() {
    this.populateChartData();
    this.setGraficoWidth();
  },
  methods: {
    createCustomTooltip: function(valor) {
      switch (this.config.tipoDato) {
        case "moneda":
          return `${util.formatearNumero(valor, this.config.decimales)} €`;
        case "porcentaje":
          return `${valor.toFixed(this.config.decimales)} %`;
        case "unidades":
          return `${valor.toFixed(this.config.decimales)}`;
        default:
          return this.data.bip_valor_3;
      }
    },
    populateChartData() {
      if (this.chartData.length === 1) {
        if (
          this.data !== null &&
          this.data !== undefined &&
          this.config !== undefined &&
          this.config.numElemGraf !== undefined &&
          this.config.conGrafico !== undefined &&
          this.config.conGrafico === 1
        ) {
          let arrayDatos = [];

          // Sacamos los datos de la grafica del objeto
          for (var key in this.data) {
            if (String(key).includes("bip_valor_grafica_")) {
              let valor = new Object();
              valor.id = Number(key.split("_").pop());
              valor.value = Number(this.data[key]);
              arrayDatos.push(valor);
            }
          }

          // Ordenamos los datos
          arrayDatos.sort(this.compare);

          // Recortamos el array con el numero de datos configurados
          let arrayFinal = arrayDatos.slice(0, this.config.numElemGraf);

          // Anhadimos los datos a chartData
          for (let i = 0; i < arrayFinal.length; i++) {
            this.chartData.push([
              i,
              arrayFinal[i].value,
              this.createCustomTooltip(arrayFinal[i].value)
            ]);
          }
        }
      }
    },
    compare: function(a, b) {
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      return 0;
    },
    onClickEliminar() {
      if (this.id != undefined) {
        this.$emit("eliminarpildora", this.id);
      }
    },
    setGraficoWidth() {
      if (
        this.$refs.pildoraParent !== undefined &&
        this.$refs.pildoraParent.clientWidth !== undefined
      ) {
        this.chartOptions.width = this.$refs.pildoraParent.clientWidth - 20;
        this.chartOptions.chartArea.width =
          this.$refs.pildoraParent.clientWidth - 20;
      }
    }
  },
  computed: {
    colorPildora() {
      return this.config !== undefined && this.config.color !== undefined
        ? this.config.color
        : this.colorPorDefecto;
    },
    nombrePildora() {
      if (this.config !== undefined && this.config.id !== undefined)
        //return this.$t(`lang.pildora.pil_${this.config.id}`);
        return this.config.name
      else return this.$t(`lang.pildora.pil_0`);
    },
    formatValor1() {
      if (
        this.data !== null &&
        this.data !== undefined &&
        this.data.bip_valor_1 !== null &&
        this.data.bip_valor_1 !== undefined &&
        this.config !== null &&
        this.config !== undefined &&
        this.config.decimales !== null &&
        this.config.decimales !== undefined &&
        this.config.tipoDato !== null &&
        this.config.tipoDato !== undefined
      ) {
        switch (this.config.tipoDato) {
          case "moneda":
            return `${util.formatearNumero(
              this.data.bip_valor_1,
              this.config.decimales
            )} €`;
          case "porcentaje":
            return `${this.data.bip_valor_1.toFixed(this.config.decimales)} %`;
          case "unidades":
            return `${this.data.bip_valor_1.toFixed(this.config.decimales)}`;
          default:
            return this.data.bip_valor_1;
        }
      } else {
        switch (this.config.tipoDato) {
          case "moneda":
            return "";
          case "porcentaje":
            return "";
          case "unidades":
            return 0 
          default:
            return "";
        }
      }
    },
    pintarFlecha(){
      if (
        this.data !== null &&
        this.data !== undefined &&
        this.data.bip_valor_3 !== null &&
        this.data.bip_valor_3 !== undefined &&
        this.data.bip_valor_2 !== null &&
        this.data.bip_valor_2 !== undefined &&
        this.data.bip_valor_1 !== null &&
        this.data.bip_valor_1 !== undefined &&
        this.config.tipoDato2 === "porcentaje"
      ){
        if (this.data.bip_valor_1 < this.data.bip_valor_3)
          return "icon-arrow-down16";
        else   
          return "icon-arrow-up16";
      }
      else {
        return "";
      }
    },
    // Devuelve el valor 2 si lo hubieres, y sino el id de la pildora
    formatValor2() {
      if (
        this.data !== null &&
        this.data !== undefined &&
        this.data.bip_valor_2 !== null &&
        this.data.bip_valor_2 !== undefined &&
        this.config !== null &&
        this.config !== undefined &&
        this.config.decimales !== null &&
        this.config.decimales !== undefined &&
        this.config.tipoDato2 !== null &&
        this.config.tipoDato2 !== undefined

      ) {
        if (this.data.bip_valor_2!==0) {
          
          switch (this.config.tipoDato2) {
            case "moneda":
              return `${util.formatearNumero(
                this.data.bip_valor_2,
                2 //this.config.decimales /* siempre sacamos dos decimales */
              )} €`;
            case "porcentaje":
              return `${this.data.bip_valor_2.toFixed(
                0 //this.config.decimales /* siempre sin decimales */
              )} %`;
            case "unidades":
              return `${this.data.bip_valor_2.toFixed(this.config.decimales)}`;
            default:
              return this.data.bip_valor_2;
          }
        } else {
         /* if (this.data !== undefined && this.data.bip_id !== undefined) {
            return `Id: ${this.data.bip_id}`;
          } else {
            return "Id: 0";
          }*/
          return "";
        }
      } else {
        return "";
      }
    },
    formatValor3() {
      if (
        this.data !== null &&
        this.data !== undefined &&
        this.data.bip_valor_3 !== null &&
        this.data.bip_valor_3 !== undefined &&
        this.config !== null &&
        this.config !== undefined &&
        this.config.decimales !== null &&
        this.config.decimales !== undefined &&
        this.config.tipoDato3!== null &&
        this.config.tipoDato3 !== undefined 
        // this.config.conValor3 !== null &&
        // this.config.conValor3 !== undefined
      ) {
        if (this.data.bip_valor_3!==0) {
          switch (this.config.tipoDato3) {
            case "moneda":
              return `${util.formatearNumero(
                this.data.bip_valor_3,
                this.config.decimales
              )} €`;
            case "porcentaje":
              return `${this.data.bip_valor_3.toFixed(
                this.config.decimales
              )} %`;
            case "unidades":
              return `${this.data.bip_valor_3.toFixed(this.config.decimales)}`;
            default:
              return this.data.bip_valor_3;
          }
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    formatPildoraId() {
      if (
        this.data !== null &&
        this.data !== undefined &&
        this.data.bip_id !== null &&
        this.data.bip_id !== undefined
      ) {
        return `Id: ${this.data.bip_id}`;
      } else {
        return "Id: 0";
      }
    },
    pintarGrafico() {
      if (
        this.data !== null &&
        this.data !== undefined &&
        this.config !== null &&
        this.config !== undefined &&
        this.config.conGrafico !== null &&
        this.config.conGrafico !== undefined &&
        this.config.conGrafico === 1
      ) {
        return this.config.conGrafico;
      } else {
        return false;
      }
    },
    formatTipoGrafico() {
      if (this.config !== undefined && this.config.tipoGrafico !== undefined) {
        return this.config.tipoGrafico;
      } else {
        return this.graficoPorDefecto;
      }
    }
  }
};
</script>